import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import {
    getTotalExtendedPriceRP,
    priceFormatObj,
} from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import DiscountedPriceTemplate from 'src/pages/reportUsage/common/DiscountedPriceTemplate';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import QuantityRPInputBoxes from './QuantityRPInputBoxes';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import { Box, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import media, { sizes } from 'src/styles/Media.styled';
import styled from 'styled-components';
import {
    noPriceErrorMsg,
    getPriceInNumberDataType,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { setCurrencyFormat } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useAdjQtyLabel } from 'src/common/hooks/useAdjQtyLabel';

const ItemPricesRP = ({
    item,
    displayPrice,
    isFromMobileView,
    isBundleItem,
    index,
    showBundlefromTableList,
    checkNewAddedProduct,
    lotSerialValueEntered,
    isChildItem,
    isFromReportScreen,
    showTopLabel,
    lotItem,
    lotItemIdx = 0,
    deleteItem,
    winWidth,
    showDeleteIcon,
}) => {
    const { t } = useTranslation();
    const isLanguageChanged = useSelector(state => state.loginReducer.isLanguageChanged);
    const adjQtyLabel = useAdjQtyLabel();
    const shouldUseWiderIpadMargin = winWidth === sizes.ipad9thGenWidth;
    const deleteBtnHeightWidth = '32px !important';
    const getUsedAndOtherQuantity = useCallback(
        (item) => {
            const qtyObj = { usedQty: null, otherQty: null };
            // Split read-only rows carry exactly one qty-type; use splitQtyType so the
            // price displays correctly based on which checkbox was selected
            if (item.isSplitLotSerialItem) {
                const splitLot = item.lotSerial?.[0];
                if (item.splitQtyType === 'used') {
                    qtyObj.usedQty = ![null, undefined, '', false].includes(item.usedQuantity)
                        ? item.usedQuantity
                        : (splitLot?.Used ?? splitLot?.used);
                } else if (item.splitQtyType === 'other') {
                    qtyObj.otherQty = ![null, undefined, '', false].includes(item.otherQuantity)
                        ? item.otherQuantity
                        : (splitLot?.Other ?? splitLot?.other);
                }
                return qtyObj;
            }
            if (
                item.otherQuantity === null ||
                item.otherQuantity === undefined
            ) {
                qtyObj.usedQty = item.usedQuantity;
                qtyObj.otherQty = null;
            } else if (
                item.usedQuantity === null ||
                item.usedQuantity === undefined
            ) {
                qtyObj.usedQty = null;
                qtyObj.otherQty = item.otherQuantity;
            }
            return qtyObj;
        },
        [item]
    );
    const deleteBtn = (
        <Box
        id={`reportUsage-reportPayment-delete-item-prices-button-${item.productCFN}-${index}`}
            component={Button}
            aria-controls="simple-menu-1"
            aria-hospopup="true"
            size="small"
            width={deleteBtnHeightWidth}
            height={deleteBtnHeightWidth}
            minWidth={deleteBtnHeightWidth}
            minHeight={deleteBtnHeightWidth}
            border="1px solid #EBEBEB"
            borderRadius={6}
            onClick={() => deleteItem(index, lotItemIdx, null, item,lotItem)}
        >
            <img
                src={DeleteLight}
                height={20}
                width={20}
            />
        </Box>
    );

    return (
        <ItemPricesContainer>
            <StyledDiv item md={12} lg={12} xl={12}>
                <QtyContainer item md={4} lg={4} xl={4}>
                    {isBundleItem &&
                    isFromMobileView &&
                    winWidth <= sizes.smalDevice ? (
                        <CustomLabel
                            id={`reportUsage-reportPayment-add-items-label-${item.productCFN}-${index}`}
                            fSize={'12px !important'}
                            color="#1010EB"
                            cursor={'pointer'}
                            opacity={1}
                            label={t(
                                'reportUsage.record.itemsList.LotSerialQtyInput.addItems'
                            )}
                            onLabelClick={() =>
                                showBundlefromTableList(
                                    true,
                                    index,
                                    item.productCFN,
                                    item?.unqId
                                )
                            }
                            width={'77px'}
                            letterSpacing={'-0.11px'}
                        />
                    ) : (
                        <>
                            {checkNewAddedProduct &&
                            !item.isSplitLotSerialItem &&
                            winWidth > sizes.mobileDevice &&
                            winWidth > sizes.smalDevice ? (
                                <QtyLayout>
                                    <InputConainter
                                        display={'flex'}
                                        justifyContent={'center'}
                                        alignItems={
                                            checkNewAddedProduct && 'flex-end'
                                        }
                                    >
                                        <QuantityRPInputBoxes
                                            item={item}
                                            index={index}
                                            lotItem={lotItem}
                                            lotItemIdx={lotItemIdx}
                                            lotSerialValueEntered={
                                                lotSerialValueEntered
                                            }
                                            showTopLabel={
                                                showTopLabel && lotItemIdx === 0
                                            }
                                            isChildItem={isChildItem}
                                            isFromReportScreen={
                                                isFromReportScreen
                                            }
                                            checkNewAddedProduct={
                                                checkNewAddedProduct
                                            }
                                        />
                                    </InputConainter>

                                    <DeleteButtonContainer
                                        gridColumns={'2/-1'}
                                        display={'flex'}
                                        justifyContent={'flex-end'}
                                        alignItems={
                                            checkNewAddedProduct && 'flex-end'
                                        }
                                    >
                                        {deleteBtn}
                                    </DeleteButtonContainer>
                                </QtyLayout>
                            ) : !isChildItem ? (
                                <>
                                    {winWidth > sizes.mobileDevice &&
                                    winWidth > sizes.smalDevice ? (
                                        <>
                                            {isChildItem ? (
                                                <QtyLayout
                                                    gridTemplateColumns={'100%'}
                                                    justifyContent={'center'}
                                                >
                                                    <StyledTextDiv>{`${t('reportUsage.record.priceOverride.AccountOwnedList.index.used') }, ${
                                                        (item.quantity)
                                                    }`}</StyledTextDiv>
                                                </QtyLayout>
                                            ) : (
                                                <QtyLayout
                                                    gridTemplateColumns={
                                                        item.isSplitLotSerialItem
                                                            ? '100%'
                                                            : undefined
                                                    }
                                                    justifyContent={
                                                        item.isSplitLotSerialItem
                                                            ? 'center'
                                                            : undefined
                                                    }
                                                >
                                                    <StyledTextDiv
                                                        textAlign={'left'}
                                                        width={'100%'}
                                                        style={
                                                            item.isSplitLotSerialItem
                                                                ? {
                                                                      display:
                                                                          'flex',
                                                                      alignItems:
                                                                          'center',
                                                                      justifyContent:
                                                                          item.salesOrg === 'S030' ? 'space-between' : 'flex-start',
                                                                      gap: winWidth >= sizes.ipadAir && winWidth <= sizes.mediumDevice ? '2px' : '8px',
                                                                  }
                                                                : undefined
                                                        }
                                                    >
                                                        {(
                                                            item.isSplitLotSerialItem
                                                                ? item.splitQtyType ===
                                                                      'used' &&
                                                                  item.unitPrice
                                                                : ![
                                                                      null,
                                                                      undefined,
                                                                      '',
                                                                      false,
                                                                  ].includes(
                                                                      getUsedAndOtherQuantity(
                                                                          item
                                                                      ).usedQty
                                                                  ) &&
                                                                  item.unitPrice
                                                        ) ? (
                                                            item.isSplitLotSerialItem ? (
                                                                // For tissue items (S030), show read-only text; for non-tissue, show editable input
                                                                item.salesOrg === 'S030' ? (
                                                                    <>
                                                                        {`${t('reportUsage.record.priceOverride.AccountOwnedList.index.used')} 1`}
                                                                        {showDeleteIcon && deleteBtn}
                                                                    </>
                                                            ) : (
                                                                <>
                                                                    <span>
                                                                        {t(
                                                                            'reportUsage.record.priceOverride.AccountOwnedList.index.used'
                                                                        )}
                                                                    </span>
                                                                    <TextWithInputs
                                                                        name={t(
                                                                            'reportUsage.itemList.used'
                                                                        )}
                                                                        placeholder={t(
                                                                            'reportUsage.replen.replenListView.qty'
                                                                        )}
                                                                        onkeyUp={(
                                                                            e
                                                                        ) =>
                                                                            lotSerialValueEntered(
                                                                                e,
                                                                                item,
                                                                                index,
                                                                                lotItem,
                                                                                lotItemIdx
                                                                            )
                                                                        }
                                                                        value={
                                                                            (lotItem?.used ===
                                                                            false
                                                                                ? ''
                                                                                : lotItem?.used)
                                                                        }
                                                                        maxLength={
                                                                            2
                                                                        }
                                                                        inputHeight={
                                                                            '40px'
                                                                        }
                                                                        inputWidth={
                                                                            '48px'
                                                                        }
                                                                        alignText={
                                                                            'center'
                                                                        }
                                                                        inputBorder={
                                                                            lotItem
                                                                                ?.isInvalidQtyMsg
                                                                                ?.length >
                                                                                0 &&
                                                                            '2px solid #FACFD6'
                                                                        }
                                                                    />
                                                                    {showDeleteIcon &&
                                                                        deleteBtn}
                                                                </>
                                                                )
                                                            ) : (
                                                                `${t('reportUsage.record.priceOverride.AccountOwnedList.index.used')} ${
                                                                    getUsedAndOtherQuantity(
                                                                        item
                                                                    ).usedQty ===
                                                                    true
                                                                        ? 1
                                                                        : getUsedAndOtherQuantity(
                                                                              item
                                                                          )
                                                                              .usedQty
                                                                }`
                                                            )
                                                        ) : null}
                                                    </StyledTextDiv>
                                                    {!item.isSplitLotSerialItem && (
                                                        <DeleteButtonContainer
                                                            gridColumns={'2/-1'}
                                                            display={'flex'}
                                                            justifyContent={
                                                                'flex-end'
                                                            }
                                                        >
                                                            {getUsedAndOtherQuantity(
                                                                item
                                                            ).usedQty !==
                                                                null &&
                                                                showDeleteIcon &&
                                                                deleteBtn}
                                                        </DeleteButtonContainer>
                                                    )}
                                                    {item.isSplitLotSerialItem &&
                                                        item.splitQtyType ===
                                                            'used' &&
                                                        item.unitPrice &&
                                                        !(
                                                            lotItem?.used === true ||
                                                            item?.usedQuantity === true ||
                                                            parseInt(
                                                                lotItem?.used
                                                            ) > 0 ||
                                                            parseInt(
                                                                item?.usedQuantity
                                                            ) > 0
                                                        ) && (
                                                            <QtyRequiredError>
                                                                {t(
                                                                    'productValidationMessages.qtyRequired'
                                                                )}
                                                            </QtyRequiredError>
                                                        )}
                                                </QtyLayout>
                                            )}
                                        </>
                                    ) : (
                                        <QtyLayout>
                                            <StyledTextDiv
                                                style={{
                                                    color: '#202124',
                                                }}
                                                textAlign={'center'}
                                                width={'100%'}
                                            >
                                                {isChildItem ? (
                                                    `${t('reportUsage.record.priceOverride.AccountOwnedList.index.used')} ${item.quantity}`
                                                ) : (
                                                    <>
                                                        {![
                                                            null,
                                                            undefined,
                                                            '',
                                                            false,
                                                        ].includes(
                                                            getUsedAndOtherQuantity(
                                                                item
                                                            ).usedQty
                                                        ) &&
                                                            item.unitPrice &&
                                                            `${t('reportUsage.itemList.used')}`}
                                                        {item.unitPrice && (
                                                            <div
                                                                style={{
                                                                    paddingLeft:
                                                                        '12px',
                                                                    fontFamily:
                                                                        'AvenirNextWorld Regular',
                                                                    fontSize:
                                                                        '14px',
                                                                }}
                                                            >
                                                                {getUsedAndOtherQuantity(
                                                                    item
                                                                ).usedQty ===
                                                                true
                                                                    ? 1
                                                                    : getUsedAndOtherQuantity(
                                                                          item
                                                                      ).usedQty}
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </StyledTextDiv>
                                        </QtyLayout>
                                    )}
                                </>
                            ) : null}
                        </>
                    )}
                </QtyContainer>
                <PriceContainer
                    item
                    md={4}
                    lg={4}
                    xl={4}
                    display={'flex'}
                    flexDirection={'column'}
                    justifyContent={'center'}
                    alignItems={'center'}
                >
                    {item.unitPrice && !isChildItem ? (
                        <>
                            {displayPrice &&
                                getUsedAndOtherQuantity(item).usedQty !==
                                    null && (
                                    <DiscountedPriceTemplate
                                        isPriceNotAvailable={
                                            (!item.accountOwned ||
                                                !item.isAccountOwned) &&
                                            (item.isPriceNotAvailable ||
                                                item.exclusionStatus ===
                                                    noPriceErrorMsg)
                                        }
                                        originalPrice={
                                            getPriceInNumberDataType(
                                                item.unitPrice
                                            ) >= 0 &&
                                            setCurrencyFormat(item.unitPrice)
                                        }
                                        adjustedPrice={
                                            !item.accountOwned &&
                                            item.overrideUnitPrice
                                        }
                                        modifiedPrice={
                                            item.accountOwned
                                                ? setCurrencyFormat(0)
                                                : getPriceInNumberDataType(
                                                      item.overrideUnitPrice
                                                  ) >= 0
                                                ? setCurrencyFormat(
                                                      item.overrideUnitPrice
                                                  )
                                                : getPriceInNumberDataType(
                                                      item.unitPrice
                                                  ) >= 0 &&
                                                  setCurrencyFormat(
                                                      item.unitPrice
                                                  )
                                        }
                                        marginLeftRp={
                                            shouldUseWiderIpadMargin
                                                ? '45px'
                                                : '20px'
                                        }
                                        textAlign={'center'}
                                        priceWidth={'100%'}
                                        priceContainerHeight={'100%'}
                                        priceContainerJustifyContent={
                                            checkNewAddedProduct
                                                ? 'center'
                                                : 'flex-start'
                                        }
                                    />
                                )}
                        </>
                    ) : null}
                </PriceContainer>
                <PriceContainer
                    item
                    md={4}
                    lg={4}
                    xl={4}
                    display={'flex'}
                    flexDirection={'column'}
                    justifyContent={'center'}
                    alignItems={'center'}
                >
                    {item.unitPrice && !isChildItem ? (
                        <>
                            {displayPrice &&
                                getUsedAndOtherQuantity(item).usedQty !==
                                    null && (
                                    <>
                                        <DiscountedPriceTemplate
                                            isPriceNotAvailable={
                                                (!item.accountOwned ||
                                                    !item.isAccountOwned) &&
                                                (item.isPriceNotAvailable ||
                                                    item.exclusionStatus ===
                                                        noPriceErrorMsg)
                                            }
                                            originalPrice={getTotalExtendedPriceRP(
                                                item.unitPrice,
                                                item?.usedQuantity,
                                            //   item?.usedQuantity?  'used':'other'
                                            'used',
                                            )}
                                            adjustedPrice={
                                                !item.accountOwned &&
                                                item.overrideUnitPrice
                                            }
                                            modifiedPrice={
                                                item.accountOwned
                                                    ? setCurrencyFormat(0)
                                                    : getTotalExtendedPriceRP(
                                                          item.overrideUnitPrice
                                                              ? item.overrideUnitPrice
                                                              : item.unitPrice,
                                                            item?.usedQuantity,
                                                        //   item?.usedQuantity?  'used':'other'
                                                        'used'
                                                      )
                                            }
                                            textAlign={'center'}
                                            priceWidth={'100%'}
                                            priceContainerHeight={'100%'}
                                            priceContainerJustifyContent={
                                                checkNewAddedProduct
                                                    ? 'center'
                                                    : 'flex-start'
                                            }
                                        />
                                    </>
                                )}
                        </>
                    ) : null}
                </PriceContainer>
            </StyledDiv>
            {item.unitPrice && !isChildItem ? (
                <>
                    {getUsedAndOtherQuantity(item).otherQty !== null && (
                        <StyledDiv item md={12} lg={12} xl={12}>
                            <QtyContainer item md={4} lg={4} xl={4}>
                                {winWidth > sizes.mobileDevice &&
                                winWidth > sizes.smalDevice ? (
                                    <QtyLayout
                                        gridTemplateColumns={
                                            item.isSplitLotSerialItem
                                                ? '100%'
                                                : undefined
                                        }
                                        justifyContent={
                                            item.isSplitLotSerialItem
                                                ? 'center'
                                                : undefined
                                        }
                                    >
                                        <StyledTextDiv
                                            // style={{
                                            //     minWidth: '110px',
                                            //     width: isFromMobileView && '110px',
                                            // }}

                                            textAlign={'left'}
                                            width={'100%'}
                                            style={
                                                item.isSplitLotSerialItem
                                                    ? {
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          justifyContent:
                                                              item.salesOrg === 'S030' ? 'space-between' : 'flex-start',
                                                          gap: winWidth >= sizes.ipadAir && winWidth <= sizes.mediumDevice ? '2px' : '8px',
                                                      }
                                                    : undefined
                                            }
                                        >
                                            {item.isSplitLotSerialItem ? (
                                                // For tissue items (S030), show read-only text; for non-tissue, show editable input
                                                item.salesOrg === 'S030' ? (
                                                    <>
                                                        {`${t('reportUsage.record.priceOverride.AccountOwnedList.index.other')} 1`}
                                                        {showDeleteIcon && deleteBtn}
                                                    </>
                                                ) : (
                                                <>
                                                 <span>
                                                        {t(
                                                            adjQtyLabel('reportUsage.record.priceOverride.AccountOwnedList.index.other')
                                                        )}
                                                    </span>
                                                    <TextWithInputs
                                                        name={t(
                                                            'reportUsage.itemList.other'
                                                        )}
                                                        placeholder={t(
                                                            'reportUsage.replen.replenListView.qty'
                                                        )}
                                                        onkeyUp={(e) =>
                                                            lotSerialValueEntered(
                                                                e,
                                                                item,
                                                                index,
                                                                lotItem,
                                                                lotItemIdx
                                                            )
                                                        }
                                                        value={
                                                            lotItem?.Other ||
                                                            lotItem?.other
                                                        }
                                                        maxLength={2}
                                                        inputHeight={'40px'}
                                                        inputWidth={'48px'}
                                                        alignText={'center'}
                                                        inputBorder={
                                                            lotItem
                                                                ?.isInvalidQtyMsg
                                                                ?.length > 0 &&
                                                            '2px solid #FACFD6'
                                                        }
                                                    />
                                                    {showDeleteIcon &&
                                                        deleteBtn}
                                                </>
                                                )
                                            ) : (
                                                `${t(adjQtyLabel('reportUsage.record.priceOverride.AccountOwnedList.index.other'))} ${
                                                    getUsedAndOtherQuantity(item)
                                                        .otherQty
                                                }`
                                            )}
                                        </StyledTextDiv>
                                        {!item.isSplitLotSerialItem && (
                                            <DeleteButtonContainer
                                                gridColumns={'2/-1'}
                                                display={'flex'}
                                                justifyContent={'flex-end'}
                                            >
                                                {showDeleteIcon
                                                    ? deleteBtn
                                                    : null}
                                            </DeleteButtonContainer>
                                        )}
                                        {item.isSplitLotSerialItem &&
                                            item.splitQtyType === 'other' &&
                                            item.unitPrice &&
                                            !(
                                                lotItem?.other === true ||
                                                item?.otherQuantity === true ||
                                                parseInt(lotItem?.other) > 0 ||
                                                parseInt(item?.otherQuantity) > 0
                                            ) && (
                                                <QtyRequiredError>
                                                    {t(
                                                        'productValidationMessages.qtyRequired'
                                                    )}
                                                </QtyRequiredError>
                                            )}
                                    </QtyLayout>
                                ) : (
                                    (winWidth <= sizes.mobileDevice ||
                                        (winWidth > sizes.mobileDevice &&
                                            winWidth <= sizes.smalDevice)) && (
                                        <StyledTextDiv
                                            // style={{
                                            //     minWidth: '110px',
                                            //     width:
                                            //         isFromMobileView && '110px',
                                            // }}
                                            textAlign={'center'}
                                            width={'100%'}
                                        >
                                            {t(adjQtyLabel('reportUsage.itemList.other'))}
                                            <div
                                                style={{
                                                    paddingLeft: '12px',
                                                    fontFamily:
                                                        'AvenirNextWorld Regular',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                {
                                                    getUsedAndOtherQuantity(
                                                        item
                                                    ).otherQty
                                                }
                                            </div>
                                        </StyledTextDiv>
                                    )
                                )}
                            </QtyContainer>
                            <PriceContainer
                                item
                                md={4}
                                lg={4}
                                xl={4}
                                display={'flex'}
                                flexDirection={'column'}
                                justifyContent={'center'}
                                alignItems={'center'}
                            >
                                {displayPrice &&
                                    getUsedAndOtherQuantity(item).otherQty !==
                                        null && (
                                        <DiscountedPriceTemplate
                                            isPriceNotAvailable={
                                                (!item.accountOwned ||
                                                    !item.isAccountOwned) &&
                                                (item.isPriceNotAvailable ||
                                                    item.exclusionStatus ===
                                                        noPriceErrorMsg)
                                            }
                                            originalPrice={
                                                getPriceInNumberDataType(
                                                    item.unitPrice
                                                ) >= 0 &&
                                                setCurrencyFormat(
                                                    item.unitPrice
                                                )
                                            }
                                            adjustedPrice={
                                                !item.accountOwned &&
                                                item.overrideUnitPrice
                                            }
                                            modifiedPrice={
                                                item.accountOwned
                                                    ? setCurrencyFormat(0)
                                                    : getPriceInNumberDataType(
                                                          item.overrideUnitPrice
                                                      ) >= 0
                                                    ? setCurrencyFormat(
                                                          item.overrideUnitPrice
                                                      )
                                                    : getPriceInNumberDataType(
                                                          item.unitPrice
                                                      ) >= 0 &&
                                                      setCurrencyFormat(
                                                          item.unitPrice
                                                      )
                                            }
                                            marginLeftRp={
                                                shouldUseWiderIpadMargin
                                                    ? '45px'
                                                    : '20px'
                                            }
                                            textAlign={'center'}
                                            priceWidth={'100%'}
                                            priceContainerHeight={'100%'}
                                            priceContainerJustifyContent={
                                                checkNewAddedProduct
                                                    ? 'center'
                                                    : 'flex-start'
                                            }
                                        />
                                    )}
                            </PriceContainer>
                            <PriceContainer
                                item
                                md={4}
                                lg={4}
                                xl={4}
                                display={'flex'}
                                flexDirection={'column'}
                                justifyContent={'center'}
                                alignItems={'center'}
                            >
                                {displayPrice &&
                                    getUsedAndOtherQuantity(item).otherQty !==
                                        null && (
                                        <>
                                            <DiscountedPriceTemplate
                                                isPriceNotAvailable={
                                                    (!item.accountOwned ||
                                                        !item.isAccountOwned) &&
                                                    (item.isPriceNotAvailable ||
                                                        item.exclusionStatus ===
                                                            noPriceErrorMsg)
                                                }
                                                originalPrice={getTotalExtendedPriceRP(
                                                    item.unitPrice,
                                                    item.otherQuantity,
                                                    'other'
                                                )}
                                                adjustedPrice={
                                                    !item.accountOwned &&
                                                    item.overrideUnitPrice
                                                }
                                                modifiedPrice={
                                                    item.accountOwned
                                                        ? setCurrencyFormat(0)
                                                        : getTotalExtendedPriceRP(
                                                              item.overrideUnitPrice
                                                                  ? item.overrideUnitPrice
                                                                  : item.unitPrice,
                                                              item.otherQuantity,
                                                              'other'
                                                          )
                                                }
                                                textAlign={'center'}
                                                priceWidth={'100%'}
                                                priceContainerHeight={'100%'}
                                                priceContainerJustifyContent={
                                                    checkNewAddedProduct
                                                        ? 'center'
                                                        : 'flex-start'
                                                }
                                            />
                                        </>
                                    )}
                            </PriceContainer>
                        </StyledDiv>
                    )}
                </>
            ) : null}
        </ItemPricesContainer>
    );
};

export default ItemPricesRP;

const StyledDiv = styled(Grid)`
    display: flex;
    justify-content: flex-start;
    ${media.mobileDevice`
        justify-content: space-between;
    `}
`;

export const ItemPricesContainer = styled(Grid)`
    display: flex;
    padding: 0 0 10px 0;
    flex-direction: column;
    height: 100%;
    max-height: 70px;
`;

export const QtyContainer = styled(Grid)``;
export const QtyLayout = styled.div`
    display: grid;
    grid-template-columns: ${({ gridTemplateColumns }) =>
        gridTemplateColumns ? gridTemplateColumns : 'auto 40px'};
    width: 115%;
    justify-content: ${({ justifyContent }) => justifyContent};
    height: 100%;
`;
const QtyRequiredError = styled.div`
    grid-column: 1 / -1;
    color: #c8102e;
    font-family: AvenirNextWorld Regular;
    font-size: 12px;
    line-height: 16px;
    text-align: left;
    white-space: nowrap;
    margin-top: 4px;
    width: 100%;
`;
const DeleteButtonContainer = styled.div`
    grid-column: ${({ gridColumns }) => gridColumns};
    display: ${({ display }) => display};
    justify-content: ${({ justifyContent }) => justifyContent};
    align-items: ${({ alignItems }) => alignItems};
`;

const InputConainter = styled.div`
    display: ${({ display }) => display};
    justify-content: ${({ justifyContent }) => justifyContent};
    align-items: ${({ alignItems }) => alignItems};
`;
const PriceContainer = styled(Grid)`
    display: ${({ display }) => display};
    flex-direction: ${({ flexDirection }) => flexDirection};
    justify-content: ${({ justifyContent }) => justifyContent};
    align-items: ${({ alignItems }) => alignItems};
`;
